/**
 * 优惠券核销
 */
import { COUPONVERIFY } from '../types';

export default {
    name: `${COUPONVERIFY}`,
    path: '/couponVerify',
    component: () => import(/* webpackChunkName: 'couponVerify' */ '@/views/couponVerify/'),
    redirect: { name: `${COUPONVERIFY}Index` },
    meta: {
        title: '优惠券核销',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${COUPONVERIFY}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'couponVerify' */ '@/views/couponVerify/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        // {
        //     name: `${COUPONVERIFY}Detail`,
        //     path: 'detail',
        //     component: () => import(/* webpackChunkName: 'couponVerify' */ '@/views/couponVerify/detail/Detail.vue'),
        // },
    ],
};
